/* eslint-disable no-useless-escape */
import React from 'react';
import PropTypes from 'prop-types';
import { Form, InputGroup, Row, Button, Alert } from 'react-bootstrap';
import { isEmpty } from 'lodash';

import * as videoOps from '../../../api/Videos/video-operations';
import Loading from '../../components/Loading';

const YOUTUBE_URL_EXPRESSION = /^(https?\:\/\/)?(www\.youtube\.com|youtu\.?be)\/.+$/;
const VideoURLField = ({
  loadInputVideo,
  updatedVideo,
  toggleButtonSwitch,
  callBackGoProVideo,
  importFileName,
  isLoadingImporFile,
  handleDatePicker,
  datePicker,
  timePicker,
  isAutoLoadData,
  setIsAutoLoadData,
  isLoadingDataVideo,
  dataLoaded,
  disabledLoadData,
  changeDisabledLoadData,
  handleButtonVideoURLForm,
  isShowInfoUploadVideo,
  isShowInfoLoadDataVideo
}) => {
  const [isValid, setIsValid] = React.useState(false);
  const [valueUrl, setValueUrl] = React.useState(videoOps.getURL(updatedVideo));
  const [videoForm, setVideoForm] = React.useState('url');
  const existVideo = !isEmpty(videoOps.getCoordinatesDataType(updatedVideo));
  const esYoutube = url => {
    const patron = new RegExp(YOUTUBE_URL_EXPRESSION);
    setIsValid(patron.test(url));
    setValueUrl(url);
    changeDisabledLoadData(false);
  };
  return (
    <>
      <Row
        style={{
          display: 'flex',
          justifyContent: 'left',
          alignItems: 'left',
          marginLeft: '1px'
        }}
      >
        <Button
          variant={videoForm === 'url' ? 'secondary' : 'light'}
          style={{ width: '15%', fontSize: 13 }}
          onClick={() => {
            setVideoForm('url');
            handleButtonVideoURLForm('url');
          }}
          disabled={videoForm === 'url'}
        >
          Url video
        </Button>
        <Button
          variant={videoForm === 'upload' ? 'secondary' : 'light'}
          style={{ width: '20%', fontSize: 13 }}
          onClick={() => {
            setVideoForm('upload');
            handleButtonVideoURLForm('upload');
          }}
          disabled={videoForm === 'upload'}
        >
          Upload video
        </Button>

        {dataLoaded ||
          (existVideo && (
            <Button
              variant={isAutoLoadData ? 'primary' : 'light'}
              style={{ width: isAutoLoadData ? '20%' : '30%', fontSize: 13 }}
              onClick={() => setIsAutoLoadData(!isAutoLoadData)}
            >
              {isAutoLoadData ? 'Advanced' : 'Close Advanced'}
            </Button>
          ))}
      </Row>
      {videoForm === 'url' && (
        <>
          <Form.Group>
            <Row
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
              }}
            >
              <Form.Control
                type="text"
                name="url"
                value={valueUrl}
                onFocus={() => toggleButtonSwitch()}
                onChange={event => {
                  esYoutube(event.target.value);
                }}
                placeholder="Where is your video?"
                isValid={isValid}
                style={{ width: isAutoLoadData ? '75%' : `${isLoadingDataVideo ? '85%' : '95%'}` }}
              />
              {isAutoLoadData && !isLoadingDataVideo && (
                <Button
                  variant="primary"
                  style={{ width: '20%', fontSize: 15 }}
                  onClick={() => callBackGoProVideo(valueUrl)}
                  disabled={disabledLoadData}
                >
                  Load
                </Button>
              )}
              {isLoadingDataVideo && <Loading />}
            </Row>
          </Form.Group>
        </>
      )}
      {videoForm === 'upload' && (
        <Form.Group>
          <Row
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <InputGroup style={{ width: isLoadingImporFile ? '85%' : '95%' }}>
              <Form.Control
                type="file"
                name="importFileName"
                className="custom-file-input"
                id="csvGoPrLogFileName"
                aria-describedby="importFileName"
                onFocus={() => toggleButtonSwitch()}
                onChange={loadInputVideo}
                placeholder="Select file..."
              />

              <InputGroup.Append>
                <Form.Label className="custom-file-label col-12" htmlFor="csvGoPrLogFileName">
                  {!isEmpty(importFileName) ? importFileName : 'Upload Video'}
                </Form.Label>
              </InputGroup.Append>
            </InputGroup>
            {isLoadingImporFile && <Loading />}
          </Row>
        </Form.Group>
      )}
      {isShowInfoUploadVideo && (
        <Alert variant="warning">Uploading video in process. it may take a few minutes...</Alert>
      )}
      {isShowInfoLoadDataVideo && (
        <Alert variant="warning">Loading data video in process. it may take a few minutes...</Alert>
      )}
      {!isAutoLoadData && (
        <Form.Group>
          <Form.Label>Date video recording</Form.Label>
          <Row
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          >
            <Form.Control
              type="date"
              name="dateGPS"
              style={{ width: '48%' }}
              value={datePicker}
              onChange={e => handleDatePicker('date', e.target.value)}
            />
            <Form.Control
              type="time"
              name="time"
              style={{ width: '48%' }}
              value={timePicker}
              onChange={e => handleDatePicker('time', e.target.value)}
              noValidate
            />
          </Row>
        </Form.Group>
      )}
    </>
  );
};
VideoURLField.defaultProps = {
  callBackGoProVideo: () => {},
  importFileName: '',
  isLoadingImporFile: false,
  dataLoaded: false,
  disabledLoadData: false,
  changeDisabledLoadData: () => {},
  handleButtonVideoURLForm: () => {},
  isShowInfoUploadVideo: false,
  isShowInfoLoadDataVideo: false
};
VideoURLField.propTypes = {
  updatedVideo: PropTypes.object.isRequired,
  toggleButtonSwitch: PropTypes.func.isRequired,
  callBackGoProVideo: PropTypes.func,
  loadInputVideo: PropTypes.func.isRequired,
  importFileName: PropTypes.string,
  isLoadingImporFile: PropTypes.bool,
  handleDatePicker: PropTypes.func.isRequired,
  datePicker: PropTypes.string.isRequired,
  timePicker: PropTypes.string.isRequired,
  isAutoLoadData: PropTypes.bool.isRequired,
  setIsAutoLoadData: PropTypes.func.isRequired,
  isLoadingDataVideo: PropTypes.bool.isRequired,
  dataLoaded: PropTypes.bool,
  disabledLoadData: PropTypes.bool,
  changeDisabledLoadData: PropTypes.func,
  handleButtonVideoURLForm: PropTypes.func,
  isShowInfoUploadVideo: PropTypes.bool,
  isShowInfoLoadDataVideo: PropTypes.bool
};

export default VideoURLField;
